module.exports = __webpack_public_path__ + "static/media/banner.4f04e12e.jpg";